import { fetchData, postData } from './fetch';
import { checkResponseData, handleMaintenancePopup, setMaintenanceInfo } from './maintenance';
import { checkSelectedCity } from './starter-city';

export const updateCookies =(cityId) =>{
  document.cookie = `cityId=${cityId}; path=/; expires=${new Date(
    Date.now() + 365 * 24 * 60 * 60 * 1000,
  )}`;
}

const redirectToCityPage = (page, cityName) => {
  setTimeout(() => {
    if (page === 'landing') {
      window.location.href = cityName;
    } else {
      window.location.reload();
    }
  }, 300);
}

export const updateProfileInformation = async (cityId, userName, page, cityName) => {
  const body = { cityId, name: userName };

  try {
    const response = await postData('/landing-profile/information', body);

    if (response?.statusCode !== 400) {
      if (page === 'landing') {
        window.location.href = cityName;
      } else {
        if (
          window.location.href.includes('catalog/') &&
          !window.location.href.includes('/popular')
        ) {
          window.location.href = '/';
        } else {
          window.location.reload();
        }
      }
    }
  } catch (error) {
    if (page === 'landing' && cityName) {
      window.location.href = cityName;
    } else {
      window.location.reload();
    }
  }
}

window.addEventListener('load', async () => {
  const citiesInputs = document.querySelectorAll('.city-input');
  const citiesLoading = document.querySelector('.cities-loading');
  const userNameInput = document.querySelector('.user-name');
  const userAuthInput = document.querySelector('.user-authorized');
  const citiesPopup = document.getElementById('cities-picker');
  const cityMaintenanceInput = document.getElementById(
    'city-maintenance-input',
  );


  await checkSelectedCity();

  if (citiesInputs) {
    [].forEach.call(citiesInputs, (input) => {
      input.addEventListener('click', async () => {

        const {
          city: cityName,
          currentcity: currentCityId,
          page,
        } = input.dataset;
        const rusName = document.querySelector(`label[for="${input.id}"]`).textContent;

        if (citiesLoading) citiesLoading.classList.add('visible');
        
        let cityId = input.value;
        const userName = userNameInput?.value;
        const userAuth = userAuthInput ? userAuthInput.value : 'false';

        if (cityMaintenanceInput) {
          cityMaintenanceInput.dataset.id = cityId;
          cityMaintenanceInput.textContent = rusName;
        }

        if (sessionStorage && sessionStorage.getItem('formValues')) {
          sessionStorage.removeItem('formValues');
        }

        if (cityId !== currentCityId) {
          document.cookie = 'cartId=; max-age=-1';

          const body = {
            type: 'delivery',
            forceReset: true,
          };

          let menuType = page === 'landing' ? 'delivery' : 'portal';

          await postData(`/cart?menuType=${menuType}`, body);
        }

        updateCookies(cityId);

        const response = await fetchData(
          `/v1/maintenance/enabled?cityId=${cityId}`,
        );

        if (checkResponseData(response.data)) {
          setMaintenanceInfo(
            response.data.title,
            response.data.text,
            response.data.imageUrl,
          );
          if (citiesPopup) citiesPopup.classList.remove('active');
          handleMaintenancePopup(cityId, cityName, page);
        } else {
          if (userAuth === 'false') {
            redirectToCityPage(page, cityName);
          } else {
            await updateProfileInformation(cityId, userName, page, cityName);
          }
        }
      });
    });
  }
});
